

import Pessoa2 from '../Images/Pessoa-1.jpg'
import Pessoa3 from '../Images/Pessoa-4.jpg'
import Leo from '../Images/Leo.png'
import Ana from '../Pessoas/Ana.jpg'
import Isabele from '../Pessoas/Isabele.jpg'
import Nathalia from '../Pessoas/Nathalia.jpg'
import Veronica from '../Pessoas/Veronica.jpg'
import Gabriela from '../Pessoas/Gabriela.jpg'



export const images = [
  { title: "Ana Simões",
  profession: "Tradutora",
   subtitle: "Fiquei muito satisfeita com o trabalho de mentoria da Lannara. Ela foi extremamente atenciosa do início ao fim e demonstrou bastante conhecimento e segurança no que faz. Seu cuidade e atenção aos detalhes foram essenciais e me ajudaram muito no meu processo. Indico a assessoria dela a todos que estão pensando ou se preparando para estudar fora.",
    img: Ana },
  {
    title: "Isabele celestino",
    profession: "Graduanda em Direto",
    subtitle: "Fiz uma sessão de mentoria Lannara, e como foi incrível! Sua forma de passar instruções de forma objetiva e prática sobre como se programar para estudar no exterior, me motivou ainda mais para me preparar para essa oportunidade. Suas experiências de morar fora e passar poor processos de seleção internacional me fizeram ter uma outra visão acerca da mobilidade entre países e estudar em instituições estrangeiras. Além disso, a conversa foi levada de forma muito descrontraída e leve, de movo que não vi o tempo passar. Lannara, você é uma mulher incrível, obrigada por tanto!",
    img: Isabele,
  },
  {
    title: "Nathalia Duarte",
    profession: "Atriz",
    subtitle: "A mentoria com a Easy Tramitt com certeza foi um diferencial na minha application. Apesar de ter as qualificações necessárias, nem sempre sabemos no expressar e escolher os pontos principais de uma carta de motivação. isso pode parecer desesperador quando tudo isso afeta e se relaciona com o nosso sonho. Com a mentoria, eu me senti muito mais confiante na prdução da minha carta e também muito feliz com o resultado! Conseguir a aprovação na UToronto com bolsa ELAP foi um sonho e eu sei que é só o começo de uma jornada que teve a mentoria como pilar fundamental.",
    img: Nathalia,
  },
  {
    title: "Gabriela",
    profession: "Servidora pública",
    subtitle: "As sessões de mentoria com a Lannara foram fundamentais para me dar um norte e decidir meu intercâmbio. Ela é muito prestativa e me ajudou muito com seu olhar e dicas que somente alguém com experiência em estudar no exterior poderia saber. Aumentou minha motivação e trouxe mais segurança, recomendo a todos que querem tirar o sonho do intercâmbio do papel!",
    img: Gabriela,
  },
  {
    title: "Verônica do Santos",
    profession: "Engenheira agrônoma",
    subtitle: "Tive sessões de mentoria com a Lannara. Todas as dicas foram fundamentais para me organizar iniciar as aplicações. Ela tem experiência recente com aprovações de mestrado em diversas universidades no exterior, isso faz muita diferença. Entender todo o processo e perceber que esse sonho - De um mestrado em uma universidade conceituada no exterior - é sim, possível. Recomendo",
    img: Veronica,
  },
  {
    title: "Leo Oliveira",
    profession: "Estudante de Engenharia Bioquímica",
    subtitle: "Tudo começou na candidatura do Stipendium Hungaricum (SH), estava inseguro em relação a minha carta de motivação, então recorri à Easy Tramitt. Achei o serviço incrível, me Norte ou em como escrever uma carta de forma convincente para a banca examinadora. Posso dizer que a correção me motivou não apenas para o SH, Como também para a bolsa ELAP. A qual felizmente conquistei graças à Easy Tramitt. A Lannara possui uma bagagem muito extensa em aprovação de bolsas de intercâmbio, tornando ela a pessoa ideal para te ajudar a conquistar a sonhada bolsa de estudo internacional. Recomendarei ela a todos aqueles que, assim como eu, possuem a ambição de estudar no exterior.",
    img: Leo,
  },
];
